
import { useEffect } from 'react';
import { useAlertStore } from '../stores/alert';
import { AlertDashboard } from './AlertDashboard';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AlertCircle, AlertTriangle, Info, Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

export const AlertPanel = () => {
  const { 
    alerts, 
    filteredAlerts,
    unacknowledgedCount,
    criticalCount,
    setAlerts, 
    acknowledgeAlert 
  } = useAlertStore();

  useEffect(() => {
    // 模拟初始告警数据
    const mockAlerts = [
      {
        id: 'alert-1',
        level: 'critical' as const,
        message: '主发动机 #3 温度过高 (105°C)',
        timestamp: new Date().toISOString(),
        source: 'engine-3',
        acknowledged: false,
      },
      {
        id: 'alert-2',
        level: 'warning' as const,
        message: '主发动机 #2 油压偏低',
        timestamp: new Date(Date.now() - 300000).toISOString(),
        source: 'engine-2',
        acknowledged: false,
      },
      {
        id: 'alert-3',
        level: 'info' as const,
        message: '系统维护计划提醒',
        timestamp: new Date(Date.now() - 600000).toISOString(),
        source: 'system',
        acknowledged: true,
      },
    ];
    
    setAlerts(mockAlerts);
  }, [setAlerts]);

  const getAlertIcon = (level: string) => {
    switch (level) {
      case 'critical': return <AlertTriangle className="h-4 w-4 text-destructive" />;
      case 'warning': return <AlertCircle className="h-4 w-4 text-warning" />;
      case 'info': return <Info className="h-4 w-4 text-primary" />;
      default: return <Info className="h-4 w-4" />;
    }
  };

  const getLevelColor = (level: string) => {
    switch (level) {
      case 'critical': return 'bg-destructive';
      case 'warning': return 'bg-warning';
      case 'info': return 'bg-primary';
      default: return 'bg-muted-foreground';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">告警系统</h2>
        <div className="flex items-center space-x-2">
          <Badge variant="destructive" className={cn(criticalCount > 0 && 'animate-pulse')}>
            {criticalCount} 紧急
          </Badge>
          <Badge variant="secondary">
            {unacknowledgedCount} 未确认
          </Badge>
        </div>
      </div>

      {/* 添加告警仪表板 */}
      <AlertDashboard />

      {/* 现有告警列表 */}
      {/* <Card className="tech-card">
        <CardHeader>
          <CardTitle>当前告警详情</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {filteredAlerts.map((alert) => (
              <Card 
                key={alert.id} 
                className={cn(
                  'tech-card transition-all duration-200',
                  !alert.acknowledged && 'border-l-4',
                  alert.level === 'critical' && 'border-l-destructive',
                  alert.level === 'warning' && 'border-l-warning',
                  alert.level === 'info' && 'border-l-primary'
                )}
              >
                <CardContent className="p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3 flex-1">
                      {getAlertIcon(alert.level)}
                      <div className="flex-1">
                        <p className="font-medium">{alert.message}</p>
                        <div className="flex items-center space-x-2 mt-1 text-sm text-muted-foreground">
                          <Clock className="h-3 w-3" />
                          <span>{new Date(alert.timestamp).toLocaleString()}</span>
                          <span>•</span>
                          <span>{alert.source}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex items-center space-x-2">
                      <Badge 
                        className={cn(
                          'text-white',
                          alert.level === 'critical' ? 'status-danger' :
                          alert.level === 'warning' ? 'status-warning' : 'status-active'
                        )}
                      >
                        {alert.level}
                      </Badge>
                      
                      {!alert.acknowledged && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => acknowledgeAlert(alert.id)}
                        >
                          确认
                        </Button>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {filteredAlerts.length === 0 && (
            <div className="text-center py-12">
              <AlertCircle className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">暂无告警信息</p>
            </div>
          )}
        </CardContent>
      </Card> */}
    </div>
  );
};
